import { Alert, Space, Typography } from "antd";
import PropTypes from "prop-types";

const DisplayAlerts = ({ alerts }) => {
  const { Text } = Typography;
  return (
    <Space orientation="vertical">
      {alerts.map(({ title, description, type, action }) => (
        <Alert
          key={`display-alert-${type}-${title}`}
          title={title}
          description={
            <Text style={{ whiteSpace: "pre-line" }}>{description}</Text>
          }
          type={type}
          action={action}
          showIcon
        />
      ))}
    </Space>
  );
};

DisplayAlerts.propTypes = {
  alerts: PropTypes.array.isRequired,
};

export default DisplayAlerts;
